import { NetworkConfigType, NetworkInfoType } from "./types";

// Images
import maticIcon from "assets/svg/matic-circular.svg";
import maticDarkIcon from "assets/svg/matic-dark.svg";
import maticxIcon from "assets/svg/maticx.svg";
import maticxDarkIcon from "assets/svg/maticx-dark.svg";

// ABI
import ERC20TOKENABI from "contracts/ethereum/ERC20.json";
import TokenXABI from "contracts/ethereum/TokenX.json";
import TokenStakeManagerABI from "contracts/ethereum/ERC20StakeManager.json";

const providerKey = process.env.NEXT_PUBLIC_ALCHEMY_KEY || "";

export const MainNetConfig: NetworkConfigType = {
  chainId: "0x1",
  supportedChainIDs: [1, 137],
  providerKey,
  chainName: "Ethereum Mainnet",
  nativeCurrency: {
    name: "Polygon",
    symbol: "Matic",
    xsymbol: "MaticX",
    decimals: 18,
  },
  blockExplorerUrls: ["https://etherscan.io"],
  contractAddresses: {
    erc20: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
    xtoken: {
      token: "0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645",
      interactionPool: "0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645",
    },
    sfc: "0x5e3Ef299fDDf15eAa0432E6e66473ace8c13D908",
  },
  abis: {
    erc20: ERC20TOKENABI,
    xtoken: {
      token: TokenXABI,
      interactionPool: TokenXABI,
    },
    sfc: TokenStakeManagerABI,
  },
};

export const NetworkInfo: NetworkInfoType = {
  icon: {
    light: maticIcon,
    dark: maticDarkIcon,
  },
  tokenXIcon: {
    light: maticxIcon,
    dark: maticxDarkIcon,
  },
};
